import React from 'react';
import styled from 'styled-components';

const SuccessIcon = () => {
return(
    <Container>
        <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16.9684 5.03712C15.0479 4.18139 12.9023 3.9694 10.8514 4.43276C8.80063 4.89611 6.95453 6.00999 5.58849 7.60826C4.22244 9.20653 3.40964 11.2036 3.2713 13.3015C3.13296 15.3995 3.6765 17.486 4.82085 19.2498C5.9652 21.0136 7.64905 22.3602 9.62127 23.0888C11.5935 23.8175 13.7484 23.8891 15.7646 23.2929C17.7809 22.6968 19.5504 21.4649 20.8093 19.7809C22.0682 18.0969 22.749 16.0511 22.7502 13.9486V12.9526C22.7502 12.3543 23.2352 11.8692 23.8335 11.8692C24.4318 11.8692 24.9168 12.3543 24.9168 12.9526V13.9492C24.9154 16.519 24.0833 19.02 22.5446 21.0782C21.006 23.1364 18.8432 24.6421 16.379 25.3707C13.9147 26.0993 11.2809 26.0118 8.87041 25.1212C6.45992 24.2307 4.40188 22.5848 3.00322 20.429C1.60457 18.2733 0.940247 15.7231 1.10933 13.159C1.27841 10.5948 2.27183 8.15398 3.94145 6.20053C5.61106 4.24709 7.8674 2.88569 10.374 2.31936C12.8805 1.75304 15.503 2.01214 17.8503 3.05802C18.3968 3.30153 18.6424 3.94197 18.3989 4.48849C18.1554 5.035 17.5149 5.28063 16.9684 5.03712Z"
                  fill="#333333"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M24.5988 4.51614C25.0221 4.93899 25.0224 5.62492 24.5996 6.0482L13.7663 16.8924C13.5631 17.0957 13.2875 17.21 13.0001 17.2101C12.7127 17.2101 12.437 17.096 12.2338 16.8928L8.9838 13.6428C8.56074 13.2197 8.56074 12.5338 8.9838 12.1107C9.40687 11.6876 10.0928 11.6876 10.5159 12.1107L12.9995 14.5943L23.0668 4.5169C23.4896 4.09362 24.1755 4.09328 24.5988 4.51614Z"
                  fill="#333333"/>
        </svg>
    </Container>
)

}
export default SuccessIcon;

const Container = styled.div`

`;